import type { ComponentProps } from "react";

import { Link, useLocation } from "react-router-dom";

import {
  SidebarMenuButton,
  SidebarMenuItem,
} from "@alaffia-technology-solutions/ds";

interface NavLinkProps extends ComponentProps<"li"> {
  href: string;
  tooltip?: string;
}

function NavLink({ href, children, tooltip, ...props }: NavLinkProps) {
  const location = useLocation();
  const pathname = location.pathname;
  const isActive = href === "/" ? pathname === "/" : pathname?.startsWith(href);

  return (
    <SidebarMenuItem {...props}>
      <SidebarMenuButton asChild isActive={isActive} tooltip={tooltip}>
        <Link to={href}>{children}</Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}

export { NavLink };
